export enum MassiveCreateFlags {
  /** Activates the progress modal */
  PROCESSING_EXCEL_FILE,
  /** Enable the button to close the progress modal when something fail */
  PROCESSING_EXCEL_FAIL,
}
